export default __webpack_public_path__ + "static/media/lemontbotanique_background_s1.a00185bb.jpg";